var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPlayerEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.81 0.8055C15.88 -0.2685 17.62 -0.2685 18.69 0.8055L20.87 2.9765C21.94 4.0505 21.94 5.7925 20.87 6.8655L6.87 20.8655C6.35 21.3815 5.65 21.6715 4.92 21.6715H0.75C0.34 21.6715 0 21.3355 0 20.9215V16.7505C0 16.0205 0.29 15.3205 0.81 14.8055L14.81 0.8055ZM17.63 1.8655C17.15 1.3785 16.35 1.3785 15.87 1.8655L13.81 3.9215L17.75 7.8605L19.81 5.8055C20.29 5.3175 20.29 4.5255 19.81 4.0375L17.63 1.8655ZM16.69 8.9215L12.75 4.9825L1.87 15.8655C1.63 16.1005 1.5 16.4185 1.5 16.7505V20.1715H4.92C5.25 20.1715 5.57 20.0395 5.81 19.8055L16.69 8.9215Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlayerEdit);
export default __webpack_public_path__ + "static/media/ico-playerEdit.94bb21d0.svg";
export { ForwardRef as ReactComponent };